import { Masonry } from '@mui/lab'
import { Grid } from '@mui/material'
import { ExplanationAccordion } from 'components'
import { useAuth, useLayout } from 'context'
import { useRefresh } from 'hooks'
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import AutoArchiveAfterImportListCard from './AutoArchiveAfterImportListCard'
import BondPolicyListCard from './BondPolicyListCard'
import MissingOhioTitleAlertDateListCard from './MissingOhioTitleAlertDateListCard'
import PortOfEntryMaintenanceListCard from './PortOfEntryMaintenanceListCard'
import PortOfLadingMaintenanceListCard from './PortOfLadingMaintenanceListCard'
import ReadyForOutboundDateListCard from './ReadyForOutboundDateListCard'
import SettingsDetailsCard from './SettingsDetailsCard'
import VehicleReleaseListCard from './VehicleReleaseListCard'
import MichiganTitleFeeListCard from './MichiganTitleFeeListCard'
import LabelPrintingCard from './LabelPrintingCard'
import QuickBooksSyncListCard from './QuickBooksSyncListCard'
// import LabelPrintersListCard from './LabelPrintersListCard'

export default function SettingsId() {
  const { permissions: ADMINISTRATION_ADD_EDIT } = useAuth()
  const layout = useLayout()
  const [refresh, handleRefresh] = useRefresh({
    bondPolicy: 0
  })

  useEffect(() => {
    layout.setTitle('Settings')

    return () => {
      layout.setTitle('')
    }
  }, [layout])

  if (!ADMINISTRATION_ADD_EDIT) {
    return <Navigate to='/' />
  }

  return (
    <Grid container spacing={2} alignItems='flex-start'>
      <Grid item xs={12}>
        <SettingsDetailsCard />
      </Grid>

      <Grid item xs={12}>
        <Masonry columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }} sequential sx={{ margin: 0 }}>
          <VehicleReleaseListCard />

          <ReadyForOutboundDateListCard />

          <AutoArchiveAfterImportListCard />

          <MissingOhioTitleAlertDateListCard />

          <PortOfLadingMaintenanceListCard />

          <PortOfEntryMaintenanceListCard />

          <BondPolicyListCard
            handleRefresh={() => {
              handleRefresh('bondPolicy')
            }}
            key={refresh.bondPolicy}
          />

          <MichiganTitleFeeListCard />

          <LabelPrintingCard />

          <QuickBooksSyncListCard />

          {/* <LabelPrintersListCard /> */}

          {/*<NoItemFoundCard /> */}
        </Masonry>
      </Grid>

      <Grid item xs={12}>
        <ExplanationAccordion>
          ||Settings are only accessible by users with "Administration add/edit" VTS2 Access. ||
        </ExplanationAccordion>
      </Grid>
    </Grid>
  )
}
